import { api, tokenStore } from './api'

/**
 * The sign-in country list (`countries_list`): public, before any token —
 * live rows are selectable, coming_soon rows are shown greyed. Returns the
 * raw `items`; lib/countries.js turns them into the page's shape.
 */
export async function fetchCountries() {
  const { data } = await api.get('/countries/list')
  return data?.items
}

/** Ask for a one-time code. Returns how long it stays valid. */
export async function requestOtp(phone) {
  const { data } = await api.post('/auth/otp-request', { phone })
  return data
}

/** Exchange a code for tokens. Also signs the user up if the number is new. */
export async function verifyOtp(phone, code) {
  const { data } = await api.post('/auth/otp-verify', { phone, code })
  tokenStore.set(data)
  return data
}

/**
 * The signed-in learner's profile — id, phone, display name, level, XP.
 *
 * Used both to restore a session on page load and right after otp-verify:
 * the token response's own `user` field is the auth-handshake shape
 * (`{id,phone,displayName,role,level}`, no XP), while the app's screens need
 * the profile shape, so this is the single source of truth for `user`
 * everywhere past login.
 */
export async function fetchProfile() {
  const { data } = await api.get('/me/profile')
  return data
}

/**
 * The profile-completion form's save — `me_updateProfile` (B3). Only the
 * fields present in the body change; the response is the whole profile as
 * it now stands, the same shape `fetchProfile` returns.
 */
export async function updateProfile(body) {
  const { data } = await api.patch('/me/update-profile', body)
  return data
}

/** The «آزاد است» badge — `me_displayNameAvailable`. Advisory; reserves nothing. */
export async function displayNameAvailable(name) {
  const { data } = await api.get('/me/display-name-available', { params: { name } })
  return data
}

/**
 * There is no server-side logout route on this API (no session/refresh-token
 * revocation endpoint exists yet) — signing out is purely a local action.
 */
export function logout() {
  tokenStore.clear()
}
